import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ErrorCodesEnum } from '~/core/services/error-code/enums/codes.enum';
import { ErrorCodeService } from '~/core/services/error-code/error-code.service';
import { OrganizerSharedAbstractGuard } from '~/organizer/shared/guards/guard.abstract';
import { OrganizerSharedActivityService } from '~/organizer/shared/services/activity/activity.service';

@Injectable({
  providedIn: 'root',
})
class PermissionsService extends OrganizerSharedAbstractGuard {
  protected readonly errorCode =
    ErrorCodesEnum.OrganizerSharedGetActivityByQueryId;

  constructor(
    private readonly activityService: OrganizerSharedActivityService,
    protected readonly errorCodeService: ErrorCodeService,
    protected readonly router: Router
  ) {
    super(errorCodeService, router);
  }

  public canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const activityId: string = route.queryParams.activityId;
    if (!activityId) {
      return of(true);
    }

    return this.activityService.getActivity(activityId).pipe(
      map((activity) => {
        const hasActivity = this.activityService.hasActivity();
        if (
          !hasActivity ||
          this.activityService.activity.sku?.toString() !== activityId
        ) {
          this.activityService.activity = activity;
        }

        return true;
      }),
      catchError(() => this.catchError())
    );
  }
}

export const OrganizerSharedGetActivityByQueryIdGuard: CanActivateFn = (
  next: ActivatedRouteSnapshot
): Observable<boolean> | true => {
  return inject(PermissionsService).canActivate(next);
};
